import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color, opacity = 0, strokeWidth }) => (
  <g
    strokeWidth={strokeWidth}
    stroke={color}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g id="TransferIconArrow">
      <path d="m94.646 43.332 15.394-15.394-15.394-15.394" />
      <path d="m63.857 74.12v-46.183h46.18" />
    </g>
    <g id="TransferIconPhone">
      <rect
        x="151.09"
        y="48.201"
        width="82.098"
        height="72.365"
        fill={opacity ? color : 'none'}
        fillOpacity={opacity}
        strokeWidth={opacity === 1 ? 0 : strokeWidth}
      />
      <rect
        x="151.09"
        y="17.675"
        width="82.098"
        height="133.42"
        rx="10.241"
        ry="10.241"
      />
    </g>
    <use transform="translate(-128.28 87.233)" xlinkHref="#TransferIconPhone" />
    <use transform="rotate(180 128 128)" xlinkHref="#TransferIconArrow" />
  </g>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} opacity={1} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const Transfer = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
  />
));

Transfer.displayName = 'Transfer';
